<template>
  <lazy-div :load="doInit">
    <v-toolbar dense color="grey lighten-3" flat>
      <v-btn text icon color="green">
        <v-icon @click="$router.push('detail')">mdi-keyboard-backspace</v-icon>
      </v-btn>
      <v-toolbar-title class="toolbar-title-custom">Policy Type: {{ polType }} - {{ this.polTypeDesc }}</v-toolbar-title>
    </v-toolbar>
    <v-tabs v-model="tabValue">
      <v-tab @click="resetTab">Listing</v-tab>
      <v-tab v-show="detailScreen">Action</v-tab>
      <v-tab-item>
        <v-card>
          <v-flex xs12>
            <form action="">
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="buscls"
                                v-model="filters.busCls"
                                :label="labels.busCls"
                                item-text="label"
                                item-value="value"
                                :error-messages="errors.collect('filtersGroup.busCls')"
                                data-vv-name="busCls"
                                :data-vv-as="labels.busCls"
                                clearable
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md6 xs12>
                              <cal-picker
                                :label="labels.effDate"
                                v-model="filters.effDate"
                                :error-messages="errors.collect('filtersGroup.effDate')"
                                data-vv-name="effDate"
                                :data-vv-as="labels.effDate"
                                data-vv-scope="filtersGroup"
                              ></cal-picker>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                        <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </form>
          </v-flex>
          <v-spacer class="mt-1"></v-spacer>
          <v-card>
            <v-flex xs12>
              <message :messages="messages"></message>
            </v-flex>
            <v-card-title>
              <v-layout row wrap>
                <v-spacer></v-spacer>
                <div>
                  <v-btn color="primary" dark class=" mr-2" @click="doNew">
                    New Permitted Business Class
                    <v-icon right>mdi-plus</v-icon>
                  </v-btn>
                </div>
              </v-layout>
            </v-card-title>
            <v-flex xs12>
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="items"
                  v-bind:options.sync="pagination"
                  :server-items-length="totalItems"
                  :loading="loading"
                  :footer-props="{'items-per-page-options': itemsPerPage }"
                  :no-data-text="noDataText"
                >
                  <template v-slot:item="row"
                    ><tr>
                      <td class="text-xs-left">{{ row.item.polType }}</td>
                      <td class="text-xs-left">{{ row.item.busCls }}</td>
                      <td class="text-xs-left">{{ row.item.busClsDesc }}</td>
                      <td class="text-xs-left">{{ row.item.effDate }}</td>
                      <td class="table-action-header">
                        <table-action
                          :rowData="row"
                          review
                          @review="doReview(row.item)"
                          remove
                          @remove="doDelete(row.item)"
                          query
                          @query="doQuery(row.item)"
                        ></table-action>
                      </td></tr
                  ></template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-card>
          <confirm ref="confirmDelete">
            <p>Are you sure you want to delete the selected record? ({{ selectedPolTypeCls.polType }}, {{ selectedPolTypeCls.busCls }})</p>
          </confirm>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-icon v-if="newPolTypeCls">mdi-plus</v-icon>
            <v-icon v-else>mdi-pencil</v-icon>
            <v-toolbar-title v-if="newPolTypeCls">Create New Permitted Business Class</v-toolbar-title>
            <v-toolbar-title v-else-if="!newPolTypeCls">Edit Permitted Business Class</v-toolbar-title>
            <v-toolbar-title v-else-if="queryMode">Query Permitted Business Class</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <message :messages="messages"></message>
            <v-container fluid grid-list-lg>
              <v-layout row>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ labels.polType }}</v-subheader>
                  <div class="queryValue">{{ polTypeClsForm.polType }} - {{ polTypeClsForm.polTypeDesc }}</div>
                </v-flex>
                <v-flex xs6 v-if="newPolTypeCls">
                  <v-autocomplete
                    :items="buscls"
                    v-model="polTypeClsForm.busCls"
                    :label="labels.busCls"
                    item-text="label"
                    item-value="value"
                    :error-messages="errors.collect('busCls')"
                    data-vv-name="busCls"
                    :data-vv-as="labels.busCls"
                    v-validate="'required'"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6 v-else-if="!newPolTypeCls || queryMode">
                  <v-subheader class="queryLabel">{{ labels.busCls }}</v-subheader>
                  <div class="queryValue">{{ polTypeClsForm.busCls }} - {{ polTypeClsForm.busClsDesc }}</div>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6>
                  <cal-picker
                    :readonly="queryMode"
                    :label="labels.effDate"
                    v-model="polTypeClsForm.effDate"
                    :error-messages="errors.collect('effDate')"
                    data-vv-name="effDate"
                    :data-vv-as="labels.effDate"
                    v-validate="'required'"
                    ref="effDate"
                  ></cal-picker>
                </v-flex>
                <v-flex xs6>
                  <cal-picker
                    :readonly="queryMode"
                    :label="labels.endDate"
                    v-model="polTypeClsForm.endDate"
                    :error-messages="errors.collect('endDate')"
                    data-vv-name="endDate"
                    :data-vv-as="labels.endDate"
                    v-validate="'checkEndDate:effDate'"
                  ></cal-picker>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 sm6 md6 lg6>
                  <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                  <div class="queryValue">{{ polTypeClsForm.createdBy }}</div>
                </v-flex>
                <v-flex xs12 sm6 md6 lg6>
                  <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                  <div class="queryValue">{{ polTypeClsForm.createdDate | formatDate }}</div>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 sm6 md6 lg6 v-if="!newPolTypeCls || queryMode">
                  <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                  <div class="queryValue">{{ polTypeClsForm.modifiedBy }}</div>
                </v-flex>
                <v-flex xs12 sm6 md6 lg6 v-if="!newPolTypeCls || queryMode">
                  <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                  <div class="queryValue">{{ polTypeClsForm.modifiedDate | formatDate }}</div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
              Cancel
              <v-icon right dark>mdi-cancel</v-icon>
            </v-btn>
            <v-btn color="primary" v-if="!queryMode" dark @click="doSave" :loading="submitting">
              Save
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </lazy-div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import clone from 'clone'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Policy Type', value: 'polType' },
        { text: 'Business Class', value: 'busCls' },
        { text: 'Business Class Description', value: 'busClsDesc' },
        { text: 'Effective Date', value: 'effDate' },
        TableConst.tableActionHeader
      ],
      labels: {
        polType: 'Policy Type',
        busCls: 'Business Class',
        busClsDesc: 'Business Class Description',
        effDate: 'Effective Date',
        endDate: 'End Date',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      filters: {
        polType: this.polType,
        busCls: undefined,
        busClsDesc: undefined,
        effDate: undefined
      },
      polTypeClsForm: {
        polType: null,
        polTypeDesc: null,
        busCls: null,
        busClsDesc: null,
        effDate: null,
        endDate: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      detailScreen: false,
      newPolTypeCls: false,
      queryMode: false,
      submitting: false,
      totalItems: 0,
      loading: false,
      tabValue: 0,
      polTypeObj: {
        polType: null,
        polTypeDesc: null
      },
      helplistMenu: {},
      helplistURI: null,
      helplist: false,
      helplistFields: null,
      fieldKey: null,
      selectedPolTypeCls: {
        polType: null,
        busCls: null
      },
      buscls: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  created() {
    this.$validator.extend(
      'checkEndDate',
      {
        getMessage: (field, args) => {
          return `The ${field} cannot be earlier than Effective Date.`
        },
        validate: (value, args) => {
          if (value) {
            if (args === void 0) args = []
            var startDate = args[0]
            if (startDate) {
              return !isAfter(removeTime(startDate), removeTime(value))
            } else return true
          } else return true
        }
      },
      { hasTarget: true }
    )
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataList('buscls')
      const apiURI = this.menu.initPolTypeCls
      if (apiURI) {
        try {
          const result = await this.$http.get(expandURI(apiURI, { polType: this.polType }))
          const { data } = result
          if (data) {
            this.polTypeObj.polType = data.data.polType.polType
            this.polTypeObj.polTypeDesc = data.data.polType.polTypeDesc
            this.helplistMenu = extractMenu(data._links)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      this.fetchData(true)
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getPolTypeClsList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let cloneFilters = clone(this.filters)
          if (cloneFilters.effDate) {
            cloneFilters.effDate = formatDisplayDateTime2(removeTime(cloneFilters.effDate))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), cloneFilters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  polType: datamap.polType,
                  busCls: datamap.busCls,
                  busClsDesc: datamap.busClsDesc,
                  effDate: formatDisplayDate(datamap.effDate)
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doNew() {
      this.resetMessages()
      this.newPolTypeCls = true
      this.queryMode = false
      this.tabValue = 1
      this.detailScreen = true
      this.polTypeClsForm.polType = this.polTypeObj.polType
      this.polTypeClsForm.polTypeDesc = this.polTypeObj.polTypeDesc
      this.polTypeClsForm.busCls = null
      this.polTypeClsForm.busClsDesc = null
      this.polTypeClsForm.effDate = new Date()
      this.polTypeClsForm.endDate = null
      this.polTypeClsForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.polTypeClsForm.createdDate = new Date()
    },
    async doReview(polTypeCls) {
      this.doGetPolTypeCls(polTypeCls)
      this.newPolTypeCls = false
      this.queryMode = false
    },
    async doQuery(polTypeCls) {
      this.doGetPolTypeCls(polTypeCls)
      this.queryMode = true
      this.newPolTypeCls = false
    },
    async doGetPolTypeCls(polTypeCls) {
      const apiURI = this.menu.getPolTypeCls
      if (apiURI && polTypeCls) {
        try {
          this.submitting = true
          const expand = {
            polType: polTypeCls.polType,
            busCls: polTypeCls.busCls
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.polTypeClsForm.polType = data.polTypeCls.polType
            this.polTypeClsForm.polTypeDesc = data.polTypeCls.polTypeDesc
            this.polTypeClsForm.busCls = data.polTypeCls.busCls
            this.polTypeClsForm.busClsDesc = data.polTypeCls.busClsDesc
            this.polTypeClsForm.effDate = data.polTypeCls.effDate
            this.polTypeClsForm.endDate = data.polTypeCls.endDate
            this.polTypeClsForm.createdBy = data.createdBy
            this.polTypeClsForm.createdDate = data.createdDate
            this.polTypeClsForm.modifiedBy = data.modifiedBy
            this.polTypeClsForm.modifiedDate = data.modifiedDate
            this.tabValue = 1
            this.detailScreen = true
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doSelect(result) {
      this.resetMessages()
      if (result && result.fieldKey1 && result.data) {
        switch (result.fieldKey1) {
          case 'busCls': {
            this.polTypeClsForm.busCls = result.data.busCls
            this.polTypeClsForm.busClsDesc = result.data.busClsDesc
            break
          }
        }
      }
    },
    async doCheck(field) {
      this.resetMessages()
      const valid = await this.$validator.validate(field)
      if (valid) {
        let key = field
        let desc = null
        let desc2 = null
        let apiURI = null
        let expand = {}
        switch (field) {
          case 'busCls': {
            apiURI = this.helplistMenu.getBusCls
            desc = 'busClsDesc'
            expand.busCls = this.polTypeClsForm.busCls
            break
          }
        }
        this.polTypeClsForm[desc] = null
        if (!desc2) {
          desc2 = desc
        }
        if (apiURI) {
          try {
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.polTypeClsForm[desc] = data[key][desc2]
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
              this.polTypeClsForm[field] = null
            }
          }
        }
      }
    },
    async doSave() {
      this.resetMessages()
      this.submitting = true
      this.$validator.validateAll().then((result) => {
        if (result) {
          const config = {
            method: this.newPolTypeCls ? 'post' : 'put',
            url: this.newPolTypeCls ? this.menu.createPolTypeCls : this.menu.updatePolTypeCls,
            data: this.polTypeClsForm
          }
          if (config.url) {
            this.$http
              .request(config)
              .then((result) => {
                const { data } = result
                this.notify(data)
                this.fetchData(true)
                this.resetTab()
              })
              .catch((err) => {
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        } else {
          this.promptFieldCheck()
        }
      })
      this.submitting = false
    },
    async doDelete(polTypeCls) {
      this.resetMessages()
      const apiURI = this.menu.deletePolTypeCls
      if (apiURI && polTypeCls) {
        this.selectedPolTypeCls.polType = polTypeCls.polType
        this.selectedPolTypeCls.busCls = polTypeCls.busCls
        this.$refs.confirmDelete.doPopUp().then((result) => {
          if (result) {
            this.$http
              .delete(expandURI(apiURI, this.selectedPolTypeCls))
              .then((result) => {
                const { data } = result
                this.notify(data)
                this.fetchData(true)
              })
              .catch((err) => {
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        })
      }
    },
    resetTab() {
      this.tabValue = 0
      this.detailScreen = false
      this.newPolTypeCls = false
    },
    doCancel() {
      this.resetTab()
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.busCls = undefined
      this.filters.busClsDesc = undefined
      this.filters.effDate = undefined
      this.pagination.page = 1
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('filtersGroup').then((result) => {
        if (result) {
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    }
  },
  computed: {
    menu() {
      return this.$store.state.polTypeParam.menu
    },
    filteredItems() {
      return this.items.filter((item) => {
        return !this.search || item.busCls.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin],
  props: ['polType', 'polTypeDesc']
}
</script>

<style>
</style>
